(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const mainImage = document.getElementById("mainProductImage");
    const thumbnails = document.querySelectorAll(".thumbnail-wrapper");
    const prevButton = document.getElementById("thumbPrev");
    const nextButton = document.getElementById("thumbNext");

    let activeIndex = 0;

    // Update active thumbnail and main image
    function updateActiveThumbnail(index) {
      document
        .querySelector(".thumbnail-wrapper.active")
        .classList.remove("active");
      thumbnails[index].classList.add("active");
      mainImage.src = thumbnails[index].querySelector("img").dataset.src;
      activeIndex = index;
    }

    // Click event for thumbnails
    thumbnails.forEach((thumbnail, index) => {
      thumbnail.addEventListener("click", function (event) {
        event.preventDefault();
        updateActiveThumbnail(index);
      });
    });

    // Next button functionality with looping
    nextButton.addEventListener("click", function (event) {
      event.preventDefault();
      if (activeIndex < thumbnails.length - 1) {
        updateActiveThumbnail(activeIndex + 1);
      } else {
        updateActiveThumbnail(0); // Loop back to first image
      }
    });

    // Previous button functionality with looping
    prevButton.addEventListener("click", function (event) {
      event.preventDefault();
      if (activeIndex > 0) {
        updateActiveThumbnail(activeIndex - 1);
      } else {
        updateActiveThumbnail(thumbnails.length - 1); // Loop back to last image
      }
    });
  });
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const pdpVariantOptions = document.querySelectorAll(".cp-product-options .variant-option");
    const quantityInput = document.getElementById("productQty");
    const increaseQty = document.getElementById("increaseQty");
    const decreaseQty = document.getElementById("decreaseQty");
    const addToCartButton = document.getElementById("CpAddToCart");
    const productPrice = document.querySelector(".cp-product-price");
    const mainImage = document.getElementById("mainProductImage");

    let selectedVariant = document.querySelector(".cp-product-options .variant-option.selected").dataset.id;
    productPrice.textContent = document.querySelector(".cp-product-options .variant-option.selected .variant-price").textContent;

    // Handle PDP variant selection
    pdpVariantOptions.forEach((option) => {
      option.addEventListener("click", function () {
        document.querySelectorAll(".cp-product-options .variant-option").forEach(opt => opt.classList.remove("selected"));
        this.classList.add("selected");
        selectedVariant = this.dataset.id;
        productPrice.textContent = this.querySelector(".variant-price").textContent;

        // Update main product image when variant is selected
        const variantImage = this.dataset.image;
        if (variantImage) {
          mainImage.src = variantImage;
        }
      });
    });

    // Quantity selector logic
    increaseQty.addEventListener("click", function () {
      quantityInput.value = parseInt(quantityInput.value) + 1;
    });

    decreaseQty.addEventListener("click", function () {
      if (quantityInput.value > 1) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
      }
    });

    // Add to cart functionality
    addToCartButton.addEventListener("click", function () {
      if (!selectedVariant) {
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: selectedVariant,
          quantity: parseInt(quantityInput.value),
        }),
      })
        .then((response) => response.json())
        .catch((error) => console.error("Error adding to cart:", error));
    });
  });
})();


(function () {
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll(".cp-faqs .faq-question").forEach((question) => {
      question.addEventListener("click", function () {
        const answer = this.nextElementSibling;
        answer.style.display =
          answer.style.display === "none" ? "block" : "none";
      });
    });
  });
})();

(function () {
  document.addEventListener("DOMContentLoaded", function () {
    const stickyAtc = document.querySelector(".cp-sticky-atc");
    const productMain = document.querySelector(".cp-product-main");
    const addToCartButton = document.querySelector(".cp-sticky-atc-button");
    const stickyVariantOptions = document.querySelectorAll(".cp-sticky-atc-options .variant-option");
    const stickyProductPrice = document.querySelector(".cp-sticky-product-price");
    const stickyMainImage = document.querySelector(".cp-sticy-atc-product-details img");
    const quantityInput = document.getElementById("productQty");

    let selectedVariant = document.querySelector(".cp-sticky-atc-options .variant-option.selected").dataset.id;

    function toggleStickyAtc() {
      if (window.scrollY > productMain.offsetTop + productMain.offsetHeight) {
        stickyAtc.style.display = "flex";
      } else {
        stickyAtc.style.display = "none";
      }
    }

    // Handle sticky variant selection and update price and image
    stickyVariantOptions.forEach(option => {
      option.addEventListener("click", function () {
        document.querySelectorAll(".cp-sticky-atc-options .variant-option").forEach(opt => opt.classList.remove("selected"));
        this.classList.add("selected");
        selectedVariant = this.dataset.id;
        stickyProductPrice.textContent = this.querySelector(".variant-price").textContent;

        // Update main image in sticky ATC
        const variantImage = this.dataset.image;
        if (variantImage) {
          stickyMainImage.src = variantImage;
        }
      });
    });

    window.addEventListener("scroll", toggleStickyAtc);

    addToCartButton.addEventListener("click", function () {
      if (!selectedVariant) {
        return;
      }

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: selectedVariant,
          quantity: parseInt(quantityInput.value)
        })
      })
      .then(response => response.json())
      .catch(error => console.error("Error adding to cart:", error));
    });
  });
})();


(function () {
    document.addEventListener("DOMContentLoaded", function () {
        const links = document.querySelectorAll(".cp-product-page-links a");

        links.forEach(link => {
            link.addEventListener("click", function (event) {
                event.preventDefault();
                const targetId = this.getAttribute("href");
                const targetElement = document.querySelector(targetId);

                if (targetElement) {
                    window.scrollTo({
                        top: targetElement.offsetTop - 100, // Adjust offset if needed
                        behavior: "smooth"
                    });
                }
            });
        });
    });
})();
